import { SkinDate } from "./skin-date"
import { ThesaurusTerm } from "./thesaurus-term"
import { TranslatedString } from "./translated-string"

export interface StateOfConservation {
    stateOfConservation: string | null,
    precision: TranslatedString | null
}

export interface Alteration {
    media: string | null,
    drawing: string,
    title: TranslatedString,
    precision: TranslatedString,
    typeOfAlteration: string, //ThesaurusTerm id
    detailedViews: string[],
}

export interface Signer {
    id?: string
    signer?: TranslatedString
    signature?: string,
    positionOfSignatory?: string, // id of ThesaurusTerm
    dateOfSignature?: SkinDate,
}

export interface CounterSignature {
    index?: number, // doesn't exist on Tryphon, used as key in list
    comment?: TranslatedString
    date?: SkinDate
    location?: TranslatedString
    reason?: string // thesaurus term id (parent thesaurus : "conditionReportMotif")
    observationCarriedPresenceOfs?: CounterSigner[]
}

export interface CounterSigner {
    index?: number, // doesn't exist on Tryphon, used as key in list
    surnameFirstName?: TranslatedString
    function?: string // thesaurus term id (parent thesaurus : "function")
    signature?: string 
}

export interface PredictedIntervention {
    typeIntervention: string | null,
    precision: TranslatedString | null
}

export interface ConditionReport {
    id: string
    associatedMedias: any
    conditionReportCS: {
        alterations: Alteration[],
        alterationDetails: DefectElement[] | null,
        referenceNumber: string,
        comments: any[],
        reportDate?: SkinDate,
        signers?: Signer[],
        stateOfConservations?: StateOfConservation[],
        predictInterventions?: PredictedIntervention[],
        reportReason?: string,
        counterSignatures?: CounterSignature[],
    }
    workflowSchema?: any
}

export const ConditionReportStatePrefix = 'ui.lifecycle-state.'
export enum ConditionReportState {
    IN_PROGRESS = 'inProgress',
    CLOSED = 'validated',
}

export interface DefectAnnotation {
    id: number
    title: TranslatedString
    comments: TranslatedString[]
    media: string
    svg: string
}

export interface DefectAlteration {
    id: number
    typeOfAlteration: ThesaurusTerm['id']
    precision: TranslatedString
    annotations: DefectAnnotation[]
}

export interface DefectMaterial {
    id: number
    material: ThesaurusTerm['id']
    alterations: DefectAlteration[]
}

export interface DefectObservation {
    id: number
    typeOfObservation: ThesaurusTerm['id']
    materialAlterations: DefectMaterial[]
}

export interface DefectElement {
    id: number
    observationAlterationDetails: DefectObservation[]
    element: TranslatedString
    precision: TranslatedString
}